import { useItemSet } from '@exam-management/common/item-set-provider';
import { useQContent } from '@exam-management/common/qcontent-provider';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { ItemSetQuestionPreviewDialog } from '../../components';
import { type ItemSetSubQuestionEditFormInput } from '../item-set-sub-question-edit-form/types';

interface FormSubQuestionPreviewModalProps {
  open: boolean;
  onClose: () => void;
}

export default function FormSubQuestionPreviewModal(
  props: Readonly<FormSubQuestionPreviewModalProps>,
) {
  const { open, onClose } = props;

  const { itemSet } = useItemSet();
  const { qContent } = useQContent();

  const { watch } = useFormContext<ItemSetSubQuestionEditFormInput>();

  const { itemSetId, paragraph, totalQuestions } = useMemo(
    () => ({
      itemSetId: itemSet.id,
      paragraph: itemSet.metadata?.paragraph ?? '',
      totalQuestions: itemSet.totalQuestions ?? 0,
    }),
    [itemSet],
  );

  const questionId = qContent.id;

  const question = watch('detail.details') ?? '';
  const correctAnswer = watch('detail.correctAnswer.value') ?? '';
  const choices =
    watch('detail.choices')?.map((choice) => ({
      label: choice.label ?? '',
      order: choice.order ?? 0,
      isCorrect: choice.value === correctAnswer,
    })) ?? [];

  return (
    <ItemSetQuestionPreviewDialog
      open={open}
      onClose={onClose}
      itemSetId={itemSetId}
      paragraph={paragraph}
      question={question}
      questionId={questionId}
      choices={choices}
      totalQuestions={totalQuestions}
    />
  );
}
